export default __webpack_public_path__ + "static/media/bgLeague.7d9d0ab3.jpg";